import { useState } from "react";
import { Plus, Minus } from "lucide-react";

const faqs = [
  {
    q: "Who is Gary Zelesky?",
    a: "Gary Zelesky is a nationally recognized keynote speaker, author, and executive leadership voice with 30+ years of experience. Known as 'The Human Defibrillator,' he has spoken to more than one million people live for clients including MasterCard, Boeing, Hilton, Hinman, CareCredit, and AAO.",
  },
  {
    q: "What is Cause for Applause?",
    a: "Cause for Applause is a referral-appreciation experience designed to help dental specialists honor referring doctors and teams while strengthening relationships and re-energizing their own staff.",
  },
  {
    q: "What topics does Gary speak on?",
    a: "Team engagement, patient experience, referral relationships, practice culture, communication, leadership, resilience, workplace attitude, and human connection. His four signature keynotes are The Passion Centered Person, Cause for Applause, Life on the Ledge, and Game On!",
  },
  {
    q: "Is Gary Zelesky a dental speaker?",
    a: "Yes. For 30+ years Gary has spoken for dental conferences, study clubs, associations, manufacturers, dental schools, and specialty practices — including AAO, AACD, Hinman, Chicago Midwinter, Seattle Study Club, Nobel Biocare, Straumann, Patterson Dental, CareCredit, and the University of the Pacific.",
  },
  {
    q: "How do I book Gary to speak at my event?",
    a: "Submit the inquiry form on this page or email Cherisse@GaryZelesky.com. Gary's team responds within 1 business day. Virtual, in-person, and hybrid formats available — domestic and international.",
  },
  {
    q: "What books has Gary written?",
    a: "Gary is the author of The Passion Centered Person (co-authored with Tim Vandehey, endorsed by Mark Victor Hansen of Chicken Soup for the Soul), Whispers from the Master, and Executive Leadership Devotional.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="bg-[#050505] py-24 md:py-32 border-t border-[#262626]">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-6">
          <span className="section-num">07 / FREQUENTLY ASKED</span>
          <div className="divider-red" />
        </div>
        <h2 className="h-display text-5xl md:text-6xl lg:text-7xl mb-14">
          Questions, <br />
          <span className="text-[#EC1985]">answered.</span>
        </h2>

        <div className="divide-y divide-[#262626] border-y border-[#262626]">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} data-testid={`faq-item-${i}`}>
                <button
                  data-testid={`faq-toggle-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-6 py-7 text-left group"
                >
                  <span className="font-display text-2xl md:text-3xl text-white group-hover:text-[#EC1985] transition-colors">
                    {f.q}
                  </span>
                  <span className="flex-shrink-0 border border-[#262626] p-2 text-[#EC1985] group-hover:border-[#EC1985] transition-colors">
                    {isOpen ? <Minus size={20} /> : <Plus size={20} />}
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? "max-h-96 pb-7" : "max-h-0"
                  }`}
                >
                  <p className="text-white/75 text-lg leading-relaxed max-w-3xl">{f.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
